export default "__VITE_ASSET__CbNn$tDL__"